export default __webpack_public_path__ + "static/media/icon2.f28016df.svg";